import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Icons from "../assets/icons";
import { useLocation } from "react-router-dom";
import scrollToRef from "../utils/scrollTarget";

const colorList = [
  { name: "Kaiper Black", code: "#000000", r: 0, g: 0, b: 0 },
  { name: "Cool Gray", code: "#6A6E77", r: 106, g: 110, b: 122 },
];

const IntroStyle = styled.ul`
  .scroll {
    min-height: calc(var(--vh, 1vh) * 100 - 50px);
    overflow: visible;
    position: relative;
  }
`;
const CiMainStyle = styled.div`
  .scroll {
    min-height: 600px;
  }
  .banner-image {
    background: url("/background/ci-bg03.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    .banner-text {
      margin: auto;
      background: #ffffff99;
      color: #000;
      width: 100%;
      padding: 50px 0;
      text-align: center;
      h1 {
        font-size: 60px;
        line-height: 1em;
        margin: auto;
      }
    }
  }
  @media (max-width: 768px) {
    .scroll {
      min-height: 400px;
    }
    .banner-image {
      .banner-text {
        h1 {
          font-size: 30px;
        }
      }
    }
  }
`;
const CiMain = ({ t, i18n }: any) => {
  return (
    <CiMainStyle>
      <div className="banner-image scroll">
        <motion.div
          initial={{ transform: "scaleX(0)", opacity: 0 }}
          animate={{ transform: "scaleX(1)", opacity: 1 }}
          transition={{ ease: "easeOut", duration: 0.7 }}
          className="banner-text"
        >
          <motion.h1
            initial={{ translateY: "-50px", opacity: 0 }}
            animate={{ translateY: "0", opacity: 1 }}
            transition={{ delay: 0.3, ease: "easeInOut", duration: 1 }}
          >
            {t("introCiTitle")}
          </motion.h1>
        </motion.div>
      </div>
    </CiMainStyle>
  );
};

const CiStyle = styled.article`
  .scroll {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 100px auto;
    height: unset;
    width: 95%;
  }
  .ci-grid-paper {
    --cell: 10px; /* 한 칸 크기 */
    --thin: 1px; /* 얇은 선 두께 */
    --thick: 2px; /* 진한 선 두께 */
    --thin-color: #eee; /* 얇은 선 색 */
    --thick-color: #ccc; /* 진한 선 색 */
    --step: 10; /* 몇 칸마다 진한 선인지 */
    border: 2px solid #ccc;
    width: 49%;
    min-height: 401.5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
    background-image:
    /* // 진한 가로선
      repeating-linear-gradient(
        0deg,
        var(--thick-color),
        var(--thick-color) var(--thick),
        transparent var(--thick),
        transparent calc(var(--cell) * var(--step))
      ),
      // 진한 세로선
      repeating-linear-gradient(
          90deg,
          var(--thick-color),
          var(--thick-color) var(--thick),
          transparent var(--thick),
          transparent calc(var(--cell) * var(--step))
        ), */
      // 얇은 가로선
      repeating-linear-gradient(
        0deg,
        var(--thin-color),
        var(--thin-color) var(--thin),
        transparent var(--thin),
        transparent var(--cell)
      ),
      // 얇은 세로선
      repeating-linear-gradient(
          90deg,
          var(--thin-color),
          var(--thin-color) var(--thin),
          transparent var(--thin),
          transparent var(--cell)
        );
  }

  .ci-box {
    .inner-box {
      h1 {
        font-size: 30px;
        color: #6a6e77;
        display: flex;
        border-bottom: 1px solid #6a6e77;
        margin-bottom: 10px;
        ::before {
          width: 6px;
          height: 22px;
          margin: auto 7px auto 0;
          background-color: #6a6e77;
        }
      }
      .ci-description {
        text-align: left;
        padding: 10px;
      }
      .ci-article {
        position: relative;
        margin-bottom: 100px;
        .ci-article-title {
          width: 100%;
          h2 {
            min-width: 150px;
            background: #6a6e77;
            color: #fff;
            min-height: 50px;
            display: flex;
            span {
              margin: auto;
            }
          }
        }
        .ci-article-grid-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .ci-article-color-box {
          color: #fff;
          .ci-color {
            .ci-color-item {
              padding: 10px 20px;
              transition: 0.1s;
              box-shadow: 0px 0px 0px 0px #000000;
              :hover {
                transition: 0.3s;
                transform: translate(3px, -3px);
                box-shadow: -3px 3px 5px 0px #00000033;
              }
              p {
                b {
                  display: block;
                  margin-bottom: 5px;
                }
              }
              &.gray {
                background-color: #6a6e77;
              }
              &.black {
                background-color: #000000;
              }
              .ci-code-ul {
                display: flex;
                .ci-code-li {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .ci-article-guide-box {
          background-color: #eee;
          padding: 50px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .ci-guide {
            display: flex;
            justify-content: center;
            align-items: center;
            svg {
              width: 100%;
            }
          }
        }
        .logo-box {
          display: flex;
          flex-direction: column;
          /* justify-content: center; */
          /* align-items: center; */
          aspect-ratio: 4 / 1;
          width: 90%;
          max-width: 500px;
          margin: 20px auto;
        }
      }
    }
  }
  h1 {
    width: 100%;
    border-bottom: 2px solid #6a6e77;
  }
  @media (max-width: 768px) {
    .ci-box {
      .inner-box {
        .ci-article {
          .ci-article-grid-box {
            flex-direction: column;
            .ci-grid-paper {
              width: 100%;
              margin: 0 auto 50px;
            }
            .logo-box {
              width: 90%;
              margin: 50px auto;
            }
          }
        }
      }
    }
  }
  @media (max-width: 480px) {
    .ci-box {
      .inner-box {
        .ci-article {
          .ci-article-grid-box {
            .ci-grid-paper {
              min-height: unset;
              margin: 0 auto 20px;
            }
            .logo-box {
              width: 95%;
              margin: 10% auto;
            }
          }
        }
      }
    }
  }
`;

const Ci = ({ t, i18n }: any) => {
  return (
    <CiStyle>
      <div className="scroll">
        <div className="ci-box">
          <div className="inner-box">
            <section className="ci-article">
              <article className="ci-article-title">
                <h1>
                  <p>{t("ciSignature")}</p>
                </h1>
              </article>
              <article className="ci-article-grid-box">
                <div className="ci-grid-paper">
                  <div className="logo-box">
                    <Icons.LogoVertical />
                  </div>
                  <div className="logo-box">
                    <Icons.LogoKrEn />
                  </div>
                  <div className="logo-box">
                    <Icons.LogoBlackS />
                  </div>
                </div>
                <div className="ci-grid-paper">
                  <div className="logo-box">
                    <Icons.LogoVerticalEn />
                  </div>
                  <div className="logo-box">
                    <Icons.LogoEnKr />
                  </div>
                  <div className="logo-box">
                    <Icons.LogoBlackWEn />
                  </div>
                </div>
              </article>
            </section>

            <section className="ci-article">
              <article className="ci-article-title">
                <h1>
                  <p>{t("ciColorSystem")}</p>
                </h1>
              </article>
              <article className="ci-article-color-box">
                <section className="ci-color">
                  {colorList.map((color) => (
                    <article
                      key={color.name}
                      className={`ci-color-item`}
                      style={{
                        backgroundColor: color.code,
                      }}
                    >
                      <p>
                        <b>{color.name}</b>
                      </p>
                      <p>{color.code}</p>
                      <ul className="ci-code-ul">
                        <li className="ci-code-li">
                          <b>R</b>
                          <span> {color.r}</span>
                        </li>
                        <li className="ci-code-li">
                          <b>G</b>
                          <span> {color.g}</span>
                        </li>
                        <li className="ci-code-li">
                          <b>B</b>
                          <span> {color.b}</span>
                        </li>
                      </ul>
                    </article>
                  ))}
                </section>
              </article>
            </section>

            <section className="ci-article">
              <article className="ci-article-title">
                <h1>
                  <p>{t("ciGuide")}</p>
                </h1>
                <div className="ci-description">
                  <p>{t("ciDescription_3")}</p>
                </div>
              </article>
              <article className="ci-article-guide-box">
                <section className="ci-guide">
                  <Icons.LogoGuide />
                </section>
              </article>
            </section>
          </div>
        </div>
      </div>
    </CiStyle>
  );
};

const IntroCi = ({ t, i18n }: any) => {
  const location = useLocation();
  const up1 = useRef(null);
  const options = {
    root: null,
    rootMargin: "-10%",
    threshold: 0,
  };
  useEffect(() => {
    switch (location.state) {
      case 0:
        scrollToRef(up1, location);
        break;
      default:
        break;
    }
  }, [location.state]);

  useEffect(() => {
    const observer = new IntersectionObserver((e) => {
      e.map((f) => {
        return f.isIntersecting && f.target.classList.add("up");
      });
    }, options);
    up1.current && observer.observe(up1.current);
  });
  return (
    <IntroStyle className="no-select">
      <CiMain t={t} i18n={i18n} />
      <section className="up-soon" ref={up1}>
        <Ci t={t} i18n={i18n} />
      </section>
    </IntroStyle>
  );
};

export default IntroCi;
